module.exports = __webpack_public_path__ + "static/media/street-view.a19e8d2e.svg";